export default __webpack_public_path__ + "static/media/blogpic1.3a4c790a.png";